import { makeStyles } from "../Utilities/ThemeHelper";
const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: 0,
    ...theme.typography.button,
    padding: theme.spacing(1.6, 2.4),
    boxShadow: "none",
    "&:active": {
      boxShadow: "none"
    },
    "&:hover": {
      backgroundImage: "none"
    },
    textShadow: "none"
  },
  fab: {},
  inner: {
    margin: "0 auto"
  },
  iconButton: {
    fontSize: theme.typography.h5.fontSize,
    boxShadow: "none",
    "&:active": {
      boxShadow: "none"
    },
    "&:hover": {
      backgroundImage: "none"
    },
    textShadow: "none"
  },
  mainLoadingButton: {
    position: "absolute"
  },
  sizeSmall: {
    padding: theme.spacing(0.8, 1.2)
  },
  iconButtonSizeSmall: {
    padding: 10,
    fontSize: theme.typography.fontSize
  },
  sizeLarge: {
    padding: theme.spacing(2.4, 3.6)
  },
  iconButtonSizeLarge: {
    padding: theme.spacing(2.25),
    fontSize: 24
  },
  startIcon: {
    display: "inherit",
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(-0.5)
  },
  endIcon: {
    display: "inherit",
    marginRight: theme.spacing(-0.5),
    marginLeft: theme.spacing(1)
  },
  tooltipFix: {
    pointerEvents: "auto !important",
    cursor: "not-allowed !important"
  }
}));
export default useStyles;